import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            分类导航
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            按需浏览不同分类的内容，快速找到你需要的路线和教程信息
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group p-6 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-semibold font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {cat.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-500">{cat.count} 篇文章</span>
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-background-200 group-hover:bg-primary-100 transition-all duration-300">
                  <i className="ri-arrow-right-line text-xs text-foreground-500 group-hover:text-primary-600"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}